import React from 'react'
import './Applications.css'
import { Warning } from '../components/Warning/Warning'
import { Content } from '../components/Content/Content'
import { useRecoilState } from 'recoil'
import { defaultActiveOrdersFilter } from '../../../../../utils/states/activeFilter.state'
import { MainContainer } from '../../../../../components/MainContainer/MainContainer'
import { Rate } from '../../components/Rate/Rate'
import { TraderBalanceBlock } from '../../components/MoneyState/TraderBalanceBlock'
import { TimeArea } from '../../components/Timearea/TimeArea'
import { Filter } from '../../components/Filter/Filter'
import { ordersFilters } from '../../../../../utils/constants/filters'
import { useGetOrdersQuery } from '../../../../../redux/services/OrdersApi'

export const Orders = () => {
  const [{ activeOrdersFilter }, changeFilter] = useRecoilState(defaultActiveOrdersFilter)
  const handleSetFilter = (filter : string) => changeFilter({ activeOrdersFilter : filter})
  const { data: newOrders } = useGetOrdersQuery({ status: 'BN', page: 1, page_size: 1 }, { pollingInterval: 10000 })
  const { data: disputeOrders } = useGetOrdersQuery({ status: 'ID', page: 1, page_size: 1 }, { pollingInterval: 10000 })
  return (
    <MainContainer>
      <div className={'applications'} style={{ height: '100%', position: 'relative' }}>
        <Rate page='orders' />
        <Warning />
        <TraderBalanceBlock />
        <h3 className={'applications_title'}>Заявки</h3>
        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '16px' }}>
          <div style={{ padding: '10px 12px', border: '1px solid #e2e5f0', borderRadius: '6px' }}>
            Новых: {newOrders?.count || 0}
          </div>
          <div style={{ padding: '10px 12px', border: '1px solid #e2e5f0', borderRadius: '6px' }}>
            В споре: {disputeOrders?.count || 0}
          </div>
        </div>
        <TimeArea />
        <Filter activeFilter={activeOrdersFilter} changeFilter={handleSetFilter} filters={ordersFilters} />
        <Content />
      </div>
    </MainContainer>
  )
}
